import React from "react";
import BugIcon from "@atlaskit/icon/core/bug";

const ScriptVariableHint = () => {
  return (
    <>
      <p>
        <b>Hint:</b> Click the <BugIcon label="" size="small" /> button in the upper-right corner to test the script.
      </p>
    </>
  );
};
export default ScriptVariableHint;
